import {DownloadOutlined} from '@ant-design/icons';
import {Button} from '@dabafinance/react-components';
import {Tooltip} from 'antd';
import {CSVLink} from 'react-csv';
import styles from './exportButton.module.scss';

export const ExportButton = ({
  csvHeaders,
  csvData,
  fileName,
  label,
  download,
  // react-csv's own hook for holding the download back — `onClick(event, done)`
  // with `asyncOnClick`, where `done(false)` cancels it. Forwarded so a caller
  // can confirm first; both are optional and change nothing when left out.
  onClick,
  asyncOnClick,
}) => {
  return (
    <CSVLink
      headers={csvHeaders}
      data={csvData}
      filename={fileName}
      onClick={onClick}
      asyncOnClick={asyncOnClick}
      type="text/csv">
      {download ? (
        <Tooltip placement="topLeft" title="Download">
          <DownloadOutlined className={styles['download-icon']} />
        </Tooltip>
      ) : (
        <Button className={styles.button} label={label} />
      )}
    </CSVLink>
  );
};
